import {
  CALL_API,
  REQUEST_DELETE,
  REQUEST_GET,
  REQUEST_POST
} from '../middleware/api'
import { ERROR } from '../components/AlertListItem'
import { EMAIL_DOMAIN, EMAIL_DOMAIN_COLLECTION, NONE } from '../schemas'

export const CREATE_EMAIL_DOMAIN_REQUEST =
  'tru/emailDomains/CREATE_EMAIL_DOMAIN_REQUEST'
export const CREATE_EMAIL_DOMAIN_SUCCEEDED =
  'tru/emailDomains/CREATE_EMAIL_DOMAIN_SUCCEEDED'
export const CREATE_EMAIL_DOMAIN_FAILED =
  'tru/emailDomains/CREATE_EMAIL_DOMAIN_FAILED'
export const CREATE_EMAIL_DOMAIN_CANCELLED =
  'tru/emailDomains/CREATE_EMAIL_DOMAIN_CANCELLED'
export const FETCH_EMAIL_DOMAINS_REQUEST =
  'tru/emailDomains/FETCH_EMAIL_DOMAINS_REQUEST'
export const FETCH_EMAIL_DOMAINS_SUCCEEDED =
  'tru/emailDomains/FETCH_EMAIL_DOMAINS_SUCCEEDED'
export const FETCH_EMAIL_DOMAINS_FAILED =
  'tru/emailDomains/FETCH_EMAIL_DOMAINS_FAILED'
export const FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST =
  'tru/emailDomains/FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST'
export const FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED =
  'tru/emailDomains/FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED'
export const FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED =
  'tru/emailDomains/FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED'
export const REMOVE_EMAIL_DOMAIN_REQUEST =
  'tru/emailDomains/REMOVE_EMAIL_DOMAIN_REQUEST'
export const REMOVE_EMAIL_DOMAIN_SUCCEEDED =
  'tru/emailDomains/REMOVE_EMAIL_DOMAIN_SUCCEEDED'
export const REMOVE_EMAIL_DOMAIN_FAILED =
  'tru/emailDomains/REMOVE_EMAIL_DOMAIN_FAILED'

const fetchEmailDomainUsersCount = (company, domainName) => ({
  [CALL_API]: {
    types: [
      FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST,
      FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED,
      FETCH_EMAIL_DOMAINS_FAILED
    ],
    endpoint: `companies/${company.id}/email_domains/user_email_domain_count.json`,
    requestType: REQUEST_GET,
    data: { domainName },
    schema: NONE
  }
})

export const fetchEmailDomains = company => ({
  [CALL_API]: {
    types: [
      FETCH_EMAIL_DOMAINS_REQUEST,
      FETCH_EMAIL_DOMAINS_SUCCEEDED,
      FETCH_EMAIL_DOMAINS_FAILED
    ],
    endpoint: `companies/${company.id}/email_domains.json`,
    requestType: REQUEST_GET,
    schema: EMAIL_DOMAIN_COLLECTION
  }
})

const createEmailDomainRequest = (company, emailDomain) => ({
  [CALL_API]: {
    types: [
      CREATE_EMAIL_DOMAIN_REQUEST,
      CREATE_EMAIL_DOMAIN_SUCCEEDED,
      CREATE_EMAIL_DOMAIN_FAILED
    ],
    endpoint: `companies/${company.id}/email_domains.json`,
    requestType: REQUEST_POST,
    schema: EMAIL_DOMAIN,
    data: { emailDomain }
  }
})

const confirmCreationOfEmailDomain = (emailDomain, count) => {
  const message =
    `Adding ${emailDomain.domainName} would add ` +
    `${count} new users to your list of managed ` +
    `users. Do you want to add ${emailDomain.domainName}?`

  return confirm(message)
}

export const createEmailDomain = (company, emailDomain) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(
        fetchEmailDomainUsersCount(company, emailDomain.domainName)
      ).then(({ response: { count } }) => {
        if (confirmCreationOfEmailDomain(emailDomain, count)) {
          resolve(dispatch(createEmailDomainRequest(company, emailDomain)))
        } else {
          reject(dispatch({ type: CREATE_EMAIL_DOMAIN_CANCELLED }))
        }
      })
    })
  }
}

export const removeEmailDomain = (company, emailDomain) => ({
  [REMOVE_EMAIL_DOMAIN_SUCCEEDED]: { emailDomain },
  [REMOVE_EMAIL_DOMAIN_FAILED]: {
    alert: {
      type: ERROR,
      message: `Unable to delete ${emailDomain.domainName}. Please try again later.`
    }
  },
  [CALL_API]: {
    types: [
      REMOVE_EMAIL_DOMAIN_REQUEST,
      REMOVE_EMAIL_DOMAIN_SUCCEEDED,
      REMOVE_EMAIL_DOMAIN_FAILED
    ],
    endpoint: `companies/${company.id}/email_domains/${emailDomain.id}.json`,
    requestType: REQUEST_DELETE,
    schema: NONE
  }
})



// WEBPACK FOOTER //
// ../src/actions/emailDomainActions.js